// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_k5zn6","avatar":"index_avatar_136vl"};